<template>
  <div v-if="sections">
    <div v-for="group in groups" :key="group.name">
      <h1 class="group-title">{{group.name | title}}</h1>
      <transition-group
        tag="div"
        class="image-grid"
        :class="screenRotation"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-bind:css="false"
        v-on:leave="leave"
        appear
      >
        <div
          class="grid-item"
          v-for="(item,idx) in group.items"
          v-bind:data-index="idx"
          :key="item.id"
          :style="getItemStyle(item)"
          @click="setImage(idx, group.name)"
        >
          <img :src="getImage(item)" @load="adjustImg" alt>
        </div>
      </transition-group>
    </div>
    <ux-modal-dialog :show="show" @close="show = !show" :full="true" :blank="true">
      <div class="ux-slides" v-bind:style="getBackground()">
        <i class="material-icons close" @click="show = !show">close</i>
        <div class="ux-slides-content">
          <i class="material-icons" @click="prevImage()">chevron_left</i>
          <span style="flex:1"></span>
          <i class="material-icons" @click="nextImage()">chevron_right</i>
        </div>
      </div>
    </ux-modal-dialog>
  </div>
  <transition-group
    v-else
    tag="div"
    class="image-grid"
    v-on:before-enter="beforeEnter"
    v-on:enter="enter"
    v-bind:css="false"
    v-on:leave="leave"
    appear
  >
    <div
      class="grid-item"
      v-for="(item,idx) in content"
      v-bind:data-index="idx"
      :key="item[keyID]"
      :style="getItemStyle(item)"
    >
      <img :src="getImage(item)" @load="adjustImg" alt>
    </div>
  </transition-group>
</template>

<script>
import anime from "animejs";
import UxModalDialog from "./UxModalDialog";

export default {
  components: { UxModalDialog },
  data() {
    return {
      screenRotation: "portrait",
      show: false,
      image: null,
      groupName: null,
      groupSelection: null
    };
  },
  props: {
    sections: {
      default: false
    },
    items: {
      default: function() {
        return [];
      }
    },
    keyID: {
      default: "id"
    },
    keyTitle: {
      default: "title"
    },
    keyURL: {
      default: "url"
    },
    title: {
      default: ""
    },
    ratio: {
      default: function() {
        return { w: 16, h: 9 };
      }
    },
    columns: {
      default: 4
    }
  },
  watch: {
    screenRotation: {
      handler(val, oldVal) {
        console.log("Orientation:" + val);
      }
    }
  },
  created() {
    let tg = this;
    function deviceDirection() {
      if (Math.abs(screen.orientation.angle) === 90) {
        tg.screenRotation = "landscape";
      } else {
        tg.screenRotation = "portrait";
      }
    }

    window.addEventListener("orientationchange", deviceDirection);
    this.$once("hook:destroyed", () => {
      window.removeEventListener("orientationchange", deviceDirection);
    });
  },
  filters: {
    title(str) {
      let words = str.split(" ").map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
      return words.join(" ");
    }
  },
  methods: {
    getBackground() {
      return {
        backgroundImage: `url(${this.image})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      };
    },
    beforeEnter(el) {
      el.style.transform = "scale(.8)";
      el.style.opacity = 0;
    },
    enter(el, done) {
      var delay = 100 + el.dataset.index * 100;
      anime({
        targets: el,
        opacity: {
          value: 1,
          duration: 600,
          easing: "linear",
          delay: delay + 100
        },
        scale: 1,
        duration: 500,
        delay: delay - 50,
        easing: "cubicBezier(0.485, 0.485, 0.245, 1.000)",
        complete: done
      });
    },
    leave(el, done) {
      var delay = el.dataset.index * 150;
      anime({
        targets: el,
        opacity: {
          value: 0,
          duration: 800,
          easing: "linear",
          delay: delay + 100
        },
        scale: 0.8,
        duration: 500,
        delay: delay - 50,
        easing: "cubicBezier(0.485, 0.485, 0.245, 1.000)",
        complete: done
      });
    },
    adjustImg(ev) {
      let img = ev.target;
      let parent = img.parentElement;
      let w = img.width;
      let h = img.height;
      let r = h / w;

      if (r > 1) {
        parent.style.gridColumnEnd = "span 2";
        parent.style.gridRowEnd = "span 2";
      }
      if (r == 1) {
        parent.style.gridColumnEnd = "span 2";
        parent.style.gridRowEnd = "span 1";
      }
      if (r > 0.6 && r < 1) {
        parent.style.gridColumnEnd = "span 2";
      }
      if (r < 0.6) {
        parent.style.gridColumnEnd = "span 4";
      }
    },
    setImage(idx, gname) {
      this.groupName = gname;
      this.groupSelection = idx;
      let group = this.groups.filter(group => group.name == gname);
      this.show = true;
      this.image = group[0].items[idx][this.keyURL];
    },
    nextImage() {
      let tgGroup = this.groups.filter(group => group.name == this.groupName);
      let tgItems = tgGroup[0].items;
      if (this.groupSelection < tgItems.length - 1) {
        this.groupSelection++;
        this.image = tgItems[this.groupSelection][this.keyURL];
      }

      this.updateGroup();
    },
    prevImage() {
      let tgGroup = this.groups.filter(group => group.name == this.groupName);
      let tgItems = tgGroup[0].items;

      if (this.groupSelection > 0) {
        this.groupSelection--;
        this.image = tgItems[this.groupSelection][this.keyURL];
      }

      this.updateGroup(true);
    },
    updateGroup(back = false) {
      let tgGroup = this.groups.filter(group => group.name == this.groupName);
      let tgItems = tgGroup[0].items;
      let gIndex = this.groups.findIndex(group => {
        return group.name == this.groupName;
      });

      if (this.groupSelection == 0 && back) {
        console.log("BEGINING");
        if (gIndex > 0) {
          let prevGroup = this.groups[gIndex - 1].name;
          console.log("Back:" + prevGroup);
          if (prevGroup !== this.groupName) {
            let pos = this.groups[gIndex - 1].items.length - 1;
            this.groupSelection = pos;
            this.groupName = prevGroup;
          }
        } else if (gIndex == 0) {
          let lastGroup = this.groups[this.groups.length - 1].name;
          let pos = this.groups[this.groups.length - 1].items.length - 1;
          this.groupSelection = pos;
          this.groupName = lastGroup;
          let temp = this.groups.filter(group => group.name == this.groupName);
          this.image = temp[0].items[pos][this.keyURL];
        }
        return;
      }

      if (!back && this.groupSelection == tgItems.length - 1) {
        if (gIndex < this.groups.length - 1) {
          this.groupName = this.groups[gIndex + 1].name;
          this.groupSelection = -1;
        } else if (gIndex == this.groups.length - 1) {
          this.groupName = this.groups[0].name;
          this.groupSelection = -1;
        }
      }
    },
    getImage(el) {
      return el[this.keyURL];
    },
    getItemStyle(el) {
      let bg = el[this.keyURL];
      return {
        backgroundImage: "url(" + bg + ")"
      };
    }
  },
  computed: {
    content() {
      let allowed = this.$store.getters.filteredTags;
      return this.items.filter(el => {
        let tags = el.tags.split(",");
        let found = tags.some(r => allowed.indexOf(r) >= 0);
        if (found) return el;
      });
    },
    groups() {
      let groups = [];
      this.content.forEach(item => {
        let tag = item.tags.split(",")[0];
        if (groups.filter(item => item.name == tag).length === 0) {
          groups.push({ name: tag, items: [item] });
        } else {
          let target = groups.find(el => el.name == tag);
          target.items.push(item);
        }
      });
      return groups;
    }
  }
};
</script>

<style lang="scss" scoped>
div.ux-slides {
  width: 100%;
  height: 100%;
  display: relative;
  i.material-icons.close {
    position: absolute;
    top: -3px;
    left: 0px;
    font-size: 2rem;
    width: 53px;
    height: 50px;
    color: rgba(white, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  div.ux-slides-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      height: 100%;
    }
    i {
      &:hover {
        cursor: pointer;
      }
      width: 50px;
      height: 50px;
      margin: 0px;
      border-radius: 999px;
      /* border: 1px solid rgba(white, 0.2); */
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 3.5rem;
      color: rgba(white, 0.5);
    }
  }
}

div.grid-item {
  background-size: cover;
  background-position: center;
}
.group-title {
  margin-top: 3rem;
  margin-bottom: 1.5rem;
}
.image-grid {
  img {
    opacity: 0;
  }
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15%, 1fr));
  grid-auto-rows: min-content;
  grid-gap: 10px;
  grid-auto-flow: dense;
  @media only screen and (max-width: 664px) {
    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
  }

  @media only screen and (max-width: 526px) {
    display: flex;
    flex-direction: column;
    margin-left: -1em;
    margin-right: -1em;
    div {
      margin-bottom: 10px;
    }
  }
  @media screen and (orientation: landscape) and (max-width: 813px) {
    .grid-item {
      width: 100%;
      height: 0px;
      padding-top: 100%;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-color: black;
      grid-column-end: span 1 !important;
      grid-row-end: span 1 !important;
      img {
        display: none;
      }
      overflow: hidden;
    }
    grid-template-columns: repeat(auto-fill, min-max(100px, 1fr));
    grid-auto-rows: unset;
    grid-gap: 10px;
    grid-auto-flow: unset;
  }
}
@media only screen and (max-width: 526px) {
  .group-title {
    margin-left: -1rem;
    margin-top: 1.5rem;
  }
}
</style>

